import React, { createContext, useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import PubSub from 'pubsub-js'
import { useImmer } from 'use-immer';
import CustomerCodingEventService from '../services/CustomerCodingEventService';
import { applicationContextActionCreator, modalActionCreator } from '../store/actions/';
import _ from 'lodash';
import { MessageService } from '../services';

export const MessageContext = createContext();
export const MessageContextContextConsumer = MessageContext.Consumer;

const MessageContextProvider = (props) => {
    const _isMounted = React.useRef(false)
    const [messages, setMessages] = useImmer([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [showAllForAccount, setShowAllForAccount] = useState(false);
    const [selectedAccount, setSelectedAccount] = useState(0);

    const dispatch = useDispatch();

    const getMessages = async () => {
        var queryObject = {};
        queryObject.skip = currentPage * pageSize;
        queryObject.take = pageSize;

        var service = new MessageService();
        var callResult = await service.getMessages(queryObject);

        if (callResult.result) {
            setMessages(callResult.model.messages);
            setTotalRecords(callResult.model.totalRecords);
        } else {
            setMessages([]);
        }
    }

    useEffect(() => {
        if (_isMounted.current) {
            getMessages();
        }
    }, [currentPage])

    useEffect(() => {
        getMessages();
        _isMounted.current = true

        return () => {
            _isMounted.current = false
        }
    }, [])

    //useEffect(() => {
    //    firstRender.current = true;
    //}, [])

    //useEffect(() => {
    //    const run = firstRender.current;
    //    if (run) {
    //        getMessages();
    //        firstRender.current = false;
    //        console.log("Rendering Message Context");
    //    }        
    //}, [firstRender.current])

    const handlePage = (selectedPage) => {
        if (currentPage !== selectedPage) {
            setCurrentPage(selectedPage);
        }
    }



    const showModal = (props, type) => {
        dispatch(modalActionCreator.showModal(props, type));
    }

    const hideModal = () => {
        dispatch(modalActionCreator.hideModal());
    }
    return (
        <MessageContext.Provider value={{
            messages,
            getMessages,
            handlePage,
            currentPage,
            totalRecords,
            pageSize,
            showModal,
            hideModal
        }}>
            {props.children}
        </MessageContext.Provider >
    )
}

export default MessageContextProvider;